<template>
  <div class="page page-matematica">
    <Header />
    <vue-headful
      title="Brincando Com os Números | Ensino Fundamental - Anos Iniciais | Editora do Brasil"
      description="Brincando Com os Números | Ensino Fundamental - Anos Iniciais | Editora do Brasil"
    />
    <section class="banner">
      <b-container class="text-center">
        <div class="banner-img">
          <div class="banner-btn" align-content="center">
            <b-button
              href="https://editoradobrasil.com.br/faleconosco/"
              target="_blank"
            >DÚVIDAS? FALE CONOSCO</b-button>
          </div>
          <img
            class="img-fluid"
            alt
            src="../../assets/anos-iniciais/numeros/topo-brincando-com-os-numeros.png"
          />
        </div>
      </b-container>
    </section>
    <section class="carousel text-center">
      <b-container class="carousel-container-text">
        <h2>Brincando Com os Números<br>Ensino Fundamental</h2>
        <p>Aprender pode ser muito divertido com a nova edição do Brincando com os Números!</p>
      </b-container>
      <b-container class="carousel-container-capas text-center">
        <div>
            <slick-carousel v-bind="settings">
              <div>
                <a
                  href="http://conteudos.editoradobrasil.com.br/flipbook/mercado/2021/degustacao/didatico/brincando-com/numeros/1/index.html"
                  target="_blank"
                >
                  <img
                    src="https://conteudos.editoradobrasil.com.br/capa/mercado/2021/brincando-com-os-numeros-1-la.jpg"
                    alt
                  />
                </a>
              </div>
              <div>
                <a
                  href="http://conteudos.editoradobrasil.com.br/flipbook/mercado/2021/degustacao/didatico/brincando-com/numeros/2/index.html"
                  target="_blank"
                >
                  <img
                    src="https://conteudos.editoradobrasil.com.br/capa/mercado/2021/brincando-com-os-numeros-2-la.jpg"
                    alt
                  />
                </a>
              </div>
              <div>
                <a
                  href="http://conteudos.editoradobrasil.com.br/flipbook/mercado/2021/degustacao/didatico/brincando-com/numeros/3/index.html"
                  target="_blank"
                >
                  <img
                    src="https://conteudos.editoradobrasil.com.br/capa/mercado/2021/brincando-com-os-numeros-3-la.jpg"
                    alt
                  />
                </a>
              </div>
              <div>
                <a
                  href="http://conteudos.editoradobrasil.com.br/flipbook/mercado/2021/degustacao/didatico/brincando-com/numeros/4/index.html"
                  target="_blank"
                >
                  <img
                    src="https://conteudos.editoradobrasil.com.br/capa/mercado/2021/brincando-com-os-numeros-4-la.jpg"
                    alt
                  />
                </a>
              </div>
              <div>
                <a
                  href="http://conteudos.editoradobrasil.com.br/flipbook/mercado/2021/degustacao/didatico/brincando-com/numeros/5/index.html"
                  target="_blank"
                >
                  <img
                    src="https://conteudos.editoradobrasil.com.br/capa/mercado/2021/brincando-com-os-numeros-5-la.jpg"
                    alt
                  />
                </a>
              </div>
            </slick-carousel>
          </div>
      </b-container>
    </section>
    <section class="destaques">
      <b-container>
        <h2 class="text-center">Destaques da coleção</h2>
        <ul>
          <li>Novo projeto gráfico;</li>
          <li>Coleção 100% alinhada à BNCC;</li>
          <li>Inclusão de novos conteúdos, mas sem deixar de lado os assuntos tradicionais mais solicitados pelos professores;</li>
          <li>Dados totalmente atualizados;</li>
          <li>Novas fotos e ilustrações;</li>
          <li>Seção especial para o trabalho com tecnologias digitais, contribuindo, de forma amigável e atrativa, para o desenvolvimento do pensamento computacional desde os primeiros anos escolares;</li>
          <li>Nova seção “Desafio”, com atividades de maior grau de complexidade, que exigem estratégias variadas e raciocínio lógico;</li>
          <li>Manual do professor em formato “U”, com orientações página a página e com indicação das habilidades da BNCC de forma pontual.</li>
        </ul>
      </b-container>
    </section>
  </div>
</template>

<script>
import Header from "../../components/Header.vue";
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
export default {
  name: "Matematica",
  components: {
    Header,
    "slick-carousel": VueSlickCarousel
  },
  data: () => ({
    settings: {
      lazyLoad: "ondemand",
      arrows: true,
      dots: false,
      focusOnSelect: true,
      infinite: false,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 3,
      touchThreshold: 3,
      variableWidth: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            arrows: false
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            arrows: false
          }
        },
        {
          breakpoint: 374,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            arrows: false
          }
        }
      ]
    }
  }),
  props: {
    msg: String
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import "../../css/_colors.scss";
.page-matematica {
  .menu {
    .menu-ef {
      background: $matematica;
      > a {
        color: white !important;
      }
      span.menu-title::after {
        content: url("../../assets/material-keyboard-arrow-down-white.svg");
      }
    }
  }
  section.banner {
    background-color: $matematica;
  }
  section.carousel {
    background: url("../../assets/ed-infantil/ed-infantil-bg-branco.png");
    background-repeat: no-repeat;
    background-position: top center;
    h2 {
      color: $matematica;
    }
  }
  section.destaques {
    background: $matematica-2
      url("../../assets/anos-iniciais/numeros/bg-destaques.png");
    background-repeat: no-repeat;
    background-position: top center;
    color: white !important;
  }
}
</style>
